import { referralStorage } from '@/utils/referralStorage';
import type { SelfReferralFormData, SessionResponse, MatchedDietitian, WorkflowState } from '@/components/self-referral/types';

export const DIRECT_BOOKING_WORKFLOW_KEY = 'direct-booking';

export interface DirectBookingStoredState {
  currentStep: 'info' | 'confirmation' | 'completed';
  formData?: SelfReferralFormData;
  sessionData?: SessionResponse;
  isLoading?: boolean;
  selectedDietitian?: MatchedDietitian;
  finalReferral?: unknown;
}

/**
 * Direct booking reuses the self-referral storage slot but tracks its own step
 * vocabulary ('info' | 'confirmation' | 'completed'), so the stored shape is not a
 * WorkflowState. The cast keeps the two step vocabularies from being conflated in
 * the type system while sharing the same persistence layer.
 */
const toWorkflowState = (state: DirectBookingStoredState): WorkflowState =>
  state as unknown as WorkflowState;

export const directBookingStorage = {
  saveSession(state: DirectBookingStoredState, token: string, expiresAt: string): void {
    referralStorage.store(toWorkflowState(state), DIRECT_BOOKING_WORKFLOW_KEY, token, expiresAt);
  },

  updateWorkflow(state: DirectBookingStoredState): void {
    referralStorage.updateWorkflow(toWorkflowState(state));
  },
};
